theme.headerSticky = (function () {
  function ScrollSticky() {
    const headerStickyWrapper = document.querySelector("header");
    const headerStickyTargetList = document.querySelectorAll(".header__sticky");

    if (!headerStickyWrapper || !headerStickyTargetList.length) return;

    let targetElementTopOffset =
      headerStickyWrapper.getBoundingClientRect().top + window.scrollY;
    let updateFrame = null;

    const updateStickyState = function () {
      if (updateFrame) return;
      updateFrame = requestAnimationFrame(() => {
        updateFrame = null;
        const shouldStick = window.scrollY > targetElementTopOffset;
        headerStickyTargetList.forEach((headerStickyTarget) => {
          headerStickyTarget.classList.toggle("sticky", shouldStick);
        });
      });
    };

    const refreshOffset = function () {
      targetElementTopOffset =
        headerStickyWrapper.getBoundingClientRect().top + window.scrollY;
      updateStickyState();
    };

    window.addEventListener("scroll", updateStickyState, { passive: true });
    window.addEventListener("resize", refreshOffset, { passive: true });
    updateStickyState();
  }

  return ScrollSticky;
})();